import { Pipe, PipeTransform } from '@angular/core';
import { AuthJwtService } from '../services/auth-jwt.service';
import { AuthService } from '../services/auth.service';
import { environment } from 'src/environments/environment';


@Pipe({
  name: 'addtoken'
})
export class AddTokenPipe implements PipeTransform {



  token: string;



  constructor(private authJwtService: AuthJwtService, private authService: AuthService) {
  }



  async transform(value: string): Promise<any> {
    try {
      const res = environment.useSSO == true ? await this.authService.getAccessToken().toPromise() : await this.authJwtService.getToken().toPromise();
      console.log(res)
      this.token = res;
      return value + '?access_token=' + this.token;
    } catch (error) {
      // Manejo de errores si ocurre algún problema con el Observable convertido en Promesa
      console.error(error);
      // Puedes lanzar una excepción aquí o devolver un valor predeterminado en caso de error.
    }
  }




}